export const environment = {
  production: true,
  buildId: '{BUILD_ID}',
};
